import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "./contexts/ThemeContext";
import { HeaderProvider } from "./contexts/HeaderContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { OrdersProvider } from "./contexts/OrdersContext";

const queryClient = new QueryClient();

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <HeaderProvider>
          <OrdersProvider>
            <App />
          </OrdersProvider>
        </HeaderProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();